module.exports = __webpack_public_path__ + "static/img/020_7.b61c877.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_7.jpg
// module id = jIqJ
// module chunks = 1